module.exports = __webpack_public_path__ + "img/icon13.6c35966e.png";